import clsx from 'clsx'
import React from 'react'

import { useSidebar } from '#hooks/useSidebar'

import type { IProps } from './interfaces'
import styles from './styles.module.scss'

export const NavigationSection = ({ title, children }: IProps): React.JSX.Element => {
  const { isCollapsed } = useSidebar()

  return (
    <div className={styles.section} data-testid={title ? `nav-section-${title.toLowerCase()}` : 'nav-section'}>
      {title && <span className={clsx(styles.title, isCollapsed && styles.titleCollapsed)}>{title}</span>}
      {children}
    </div>
  )
}
